class TransactionPeriod
  constructor: (obj = {}) ->
    _.merge(@, obj)
  localizedName: ->
    if HM.is_russian
      @name_ru
    else
      @name
  getNextDate: (date) ->
    next_date = @interval(date)
    # If date is the last day of month, then next month it should also be the last day of month
    next_date = hm_date.endOfMonth(next_date) if @process_end_of_month && hm_date.endOfMonth_f(date) == date
    return next_date

raw_periods = [
  {
    id: 1
    name: '---'
    periods: [
      { name: 'Everyday'      , name_ru: 'Каждый день'  , days: 1, interval: (date) -> hm_date.addDays(date, 1) }
      { name: 'Every week'    , name_ru: 'Каждую неделю'  , days: 7 , interval: (date) -> hm_date.addDays(date, 7) }
      { name: 'Every month'   , name_ru: 'Каждый месяц'     , days: 30, interval: ((date) -> hm_date.addMonths(date, 1)), process_end_of_month: true }
      { name: 'Every 3 months', name_ru: 'Каждые 3 месяца'  , days: 91, interval: ((date) -> hm_date.addMonths(date, 3)), process_end_of_month: true }
      { name: 'Every 6 months', name_ru: 'Каждые полгода', days: 182, interval: ((date) -> hm_date.addMonths(date, 6)), process_end_of_month: true }
      { name: 'Every year'    , name_ru: 'Каждый год'    , days: 365, interval: ((date) -> hm_date.addMonths(date, 12)), process_end_of_month: true }
    ]
  }

  {
    id: 2
    name: '---'
    periods: [
      { name: 'Every workday', name_ru: 'По будням'    , days: 8 , interval: (date) -> hm_date.addDays(date, 1) } # Magic number
      { name: 'Every weekend', name_ru: 'По выходным'  , days: 9 , interval: (date) -> hm_date.addDays(date, 1) } # Magic number
      { name: '2 on 2 off'   , name_ru: '2 через 2 дня', days: 10, interval: (date) -> hm_date.addDays(date, 1) } # Magic number
      { name: 'Every 2 days' , name_ru: 'Каждые 2 дня' , days: 2, interval: (date) -> hm_date.addDays(date, 2) }
      { name: 'Every 3 days' , name_ru: 'Каждые 3 дня' , days: 3, interval: (date) -> hm_date.addDays(date, 3) }
      { name: 'Every 4 days' , name_ru: 'Каждые 4 дня' , days: 4, interval: (date) -> hm_date.addDays(date, 4) }
      { name: 'Every 5 days' , name_ru: 'Каждые 5 дней', days: 5, interval: (date) -> hm_date.addDays(date, 5) }
      { name: 'Every 6 days' , name_ru: 'Каждые 6 дней', days: 6, interval: (date) -> hm_date.addDays(date, 6) }
    ]
  }

  {
    id: 3
    name: '---'
    periods: [
      { name: 'Every 2 weeks', name_ru: 'Каждые 2 недели', days: 14, interval: (date) -> hm_date.addDays(date, 14) }
      { name: 'Every 3 weeks', name_ru: 'Каждые 3 недели', days: 21, interval: (date) -> hm_date.addDays(date, 21) }
      { name: 'Every 4 weeks', name_ru: 'Каждые 4 недели', days: 28, interval: (date) -> hm_date.addDays(date, 28) }
      { name: 'Every 1.5 months', name_ru: 'Каждые 1.5 месяца', days: 45, interval: (date) -> hm_date.addDays(date, 45) }
      { name: 'Every 2 months'  , name_ru: 'Каждые 2 месяца'  , days: 60, interval: ((date) -> hm_date.addMonths(date, 2)), process_end_of_month: true }
      { name: 'Every 4 months'  , name_ru: 'Каждые 4 месяца'  , days: 121, interval: ((date) -> hm_date.addMonths(date, 4)), process_end_of_month: true }
    ]
  }
]

module.exports = _.map raw_periods, (period_category) ->
  period_category.periods = _.map period_category.periods, (period) -> new TransactionPeriod(period)
  period_category
